<!--
  - Copyright (c) 2018 BarD Software s.r.o
  -->

<template>
    <div class="notification-bell dropdown">
        <button id="bell-box-dropdown" class="btn border-0" data-toggle="dropdown">
            <i class="fas fa-bell"></i>
            <i class="fas fa-circle text-danger d-none"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="bell-box-dropdown">
            <div v-show="hasEvents()">
                <div class="list-group">
                    <div v-for="e in notifications" class="list-group-item list-group-item-action">
                        <div v-if="e.type === 'ProjectCreate'">
                            <b>{{ e.author.name }}</b> has created new project <b>{{ e.projectName }}</b>
                        </div>
                        <div v-if="e.type === 'ProjectRename'">
                            <b>{{ e.author.name }}</b> has renamed project <b>{{ e.projectName }}</b> to <b>{{ e.newProjectName }}</b>
                        </div>
                        <div v-if="e.type === 'NewInvite'">
                            You was invited by <b>{{ e.author.name }}</b> to <b>{{ e.teamName }}</b> team
                        </div>
                        <div v-if="e.type === 'ProjectRemove'">
                            <b>{{ e.author.name }}</b> has removed <b>{{ e.projectName }}</b>
                        </div>
                        <div v-if="e.type === 'ProjectRevert'">
                            <b>{{ e.author.name }}</b> has reverted project <b>{{ e.projectName }}</b>
                        </div>
                        <div v-if="e.type === 'ProjectLockStatusChange' && e.locked">
                            <b>{{ e.author.name }}</b> has acquired lock on project <b>{{ e.projectName }}</b>
                        </div>
                        <div v-if="e.type === 'ProjectLockStatusChange' && !e.locked">
                            <b>{{ e.author.name }}</b> has released lock on project <b>{{ e.projectName }}</b>
                        </div>
                        <div class="small text-right">{{ timestampString(e.timestamp) }}</div>
                    </div>
                </div>
            </div>
            <div v-show="!hasEvents()" class="text-center">
                No new notifications.
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./BellNotification.ts"></script>
